import { render, staticRenderFns } from "./EditorGroupList.vue?vue&type=template&id=4713c287&"
import script from "./EditorGroupList.vue?vue&type=script&lang=js&"
export * from "./EditorGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports